import { render, staticRenderFns } from "./Documentations.vue?vue&type=template&id=05d7aaa9&scoped=true"
import script from "./Documentations.vue?vue&type=script&lang=js"
export * from "./Documentations.vue?vue&type=script&lang=js"
import style0 from "./Documentations.vue?vue&type=style&index=0&id=05d7aaa9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d7aaa9",
  null
  
)

export default component.exports